import { combineReducers } from 'redux';

import error from './error';
import ids from './ids';
import isLoading from './isLoading';
import links from './links';
import page from './page';

/**
 * @typedef {{
 *    error: string,
 *    ids: string[],
 *    isLoading: boolean,
 *    links:Record<string, import("modules/global/generic.types").Link>,
 *    page: import("modules/global/generic.types").Page
 * }} AuditUILinkReducer
 */

export default combineReducers({ error, ids, isLoading, links, page });
